module.exports = __webpack_public_path__ + "img/pluto.47ac5d7c.png";